import setRefreshChart from './setRefreshChart'

export default {
  setRefreshChart,
}
